export default __webpack_public_path__ + "static/media/linkedIn-blue.d875e8ec.svg";